import { createReportSettings, reports, widgetReport } from 'api/report';
import { actions, types } from 'reducers/dashboard/location/vehicleBodyTypes';
import { call, put, takeLatest } from 'redux-saga/effects';

function* fetchReport({ requestDate, timezone, period, location }) {
  try {
    const response = yield call(
      widgetReport,
      reports.VEHICLE_BODY_TYPES_WITH_SESSIONS,
      createReportSettings(requestDate, timezone, period, null, location)
    );

    yield put(actions.reportSuccess(requestDate, timezone, period, response.data));
  } catch (e) {
    yield put(actions.reportFailure(requestDate, timezone, period, e));
  }
}

export default function* vehicleBodyTypes() {
  yield takeLatest(types.REPORT_REQUEST, fetchReport);
}
